import { Link } from "react-router-dom";
import { BsDatabaseGear } from "react-icons/bs";

const BackOfficeButton = () => {

    return (

        <div align="center">            
            <Link to="/backoffice">
                <button className="menu-btn" type="button"><BsDatabaseGear />&nbsp;&nbsp;BackOffice</button>
            </Link>            
        </div>

    )
}

export default BackOfficeButton;